import React from 'react';
import {Col, Container, Row} from "react-bootstrap";


function Leadingdemand(props) {
    return (
        <section className="Enablement tekrevol_dark_bg  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
                        <div className="example" data-text="Enablement">
                            <h2>Technology Enablement Solutions For Healthcare Software Development</h2>
                            <p>These tools, frameworks, and technologies facilitate the creation, deployment, and management of healthcare software applications. Our healthcare software developers build robust, secure, and scalable software solutions.</p>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <div className="tech-box">
                            <div className="tech_num">
                                <p>01</p>
                            </div>
                            <div className="tech_box_content">
                                <h6>Medical billing software</h6>
                                <p>It is a specialized tool to automate and streamline billing and invoicing. It helps manage patient billing information, insurance claims, and financial transactions related to healthcare services.</p>
                            </div>
                        </div>
                        <div className="tech-box ">
                            <div className="tech_num">
                                <p>03</p>
                            </div>
                            <div className="tech_box_content">
                                <h6>Healthcare CRM (Customer Relationship Management) software</h6>
                                <p>It is designed for the healthcare industry to enhance relationships with patients, healthcare providers, and other stakeholders. It empowers healthcare organizations to centralize patient data, streamline communication, and improve patient engagement.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="resp_order">
                        <div className="tech-box">
                            <div className="tech_num">
                                <p>02</p>
                            </div>
                            <div className="tech_box_content">
                                <h6>Medical inventory software</h6>
                                <p>It is a vital tool to effectively manage and optimize medical supplies, equipment, and medication inventory. This specialized software streamlines inventory tracking, ordering, and restocking processes.</p>
                            </div>
                        </div>
                        <div className="tech-box ">
                            <div className="tech_num">
                                <p>04</p>
                            </div>
                            <div className="tech_box_content">
                                <h6>Hospital Management Software</h6>
                                <p>This comprehensive software solution automates various administrative, clinical, and financial processes within a hospital or healthcare facility. It integrates different departments and functions, facilitating efficient operations management and enhancing patient care.</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Leadingdemand;